import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TimeConverterProvider } from '@services/helpers/time-converter';

@Injectable()
export class TimeServiceProvider {
	constructor(
		private datePipe: DatePipe,
		// private timeFilter: TimeFilterPipe,
		private timeConverter: TimeConverterProvider
	) {}

	getDateString(date: any): string {
		if (typeof date === 'string') {
			return date;
		}
		let month = date.getMonth() + 1;
		month = month.toString().length > 1 ? month : `0${month}`;

		const day = parseInt(date.getDate());
		const days = day.toString().length > 1 ? day : `0${day}`;

		return `${date.getFullYear()}-${month}-${days}`;
	}

	formDateNotDependentOnTimezone(date: Date): Date {
		return new Date(date.getFullYear(), date.getMonth(), date.getDate());
	}

	getProperDate(dateString): Date {
		if (
			typeof dateString !== 'undefined' &&
			dateString != null &&
			dateString.length > 19
		) {
			dateString = dateString.substring(0, 19);
			dateString = dateString.replace(/T/g, ' ');
			dateString = dateString.replace(/\-/g, '/');

			let tempDate: any = new Date(dateString);
			tempDate = Date.UTC(
				tempDate.getFullYear(),
				tempDate.getMonth(),
				tempDate.getDate(),
				tempDate.getHours(),
				tempDate.getMinutes(),
				tempDate.getSeconds()
			);
			return new Date(tempDate);
		} else if (Object.prototype.toString.call(dateString) === '[object Date]') {
			return new Date(dateString);
		}

		return null;
	}

	parseDateFromJSON(key, value) {
		const dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/;
		if (typeof value === 'string' && dateFormat.test(value)) {
			return new Date(value);
		}

		return value;
	}

	getTimeExp(dateExp): number {
		const regExp = /(\d{1,2})\:(\d{1,2})/;

		return parseInt(dateExp.replace(regExp, '$1$2'));
	}

	getDateInFormat(date, format: string) {
		let result, ISOString, dateArr;

		if (!(date instanceof Date)) {
			date = date ? new Date(date) : new Date();
		}

		ISOString = date.toISOString();
		dateArr = ISOString.split('T');

		switch (format) {
			case 'date':
				result = this.datePipe.transform(date, 'yyyy-MM-dd');
				break;
			case 'time':
				result = dateArr[1].split('.')[0];
				break;
			case 'full':
				result = this.datePipe.transform(date, "yyyy-MM-dd'T'HH:mm:ss");
				break;
			default:
				result = {
					date: dateArr[0],
					time: dateArr[1].split('.')[0],
					fullDate: ISOString.split('.')[0]
				};
		}

		return result;
	}

	isIn24Format(time = ''): boolean {
		if (!time) {
			return false;
		}
		return time.endsWith('00') && time.length === 8;
	}

	getHour(time): number {
		if (time && typeof time === 'string') {
			const tmpArr = time.split(':');
			return parseInt(tmpArr[0], 10);
		}
		return 0;
	}

	getMinutes(time): number {
		if (time && typeof time === 'string') {
			const tmpArr = time.split(':');
			return parseInt(tmpArr[1], 10);
		}
		return 0;
	}

	date2Array(date): any {
		if (date) {
			date = this.checkTypeof(date);
			const tmpArr = date.split('-');

			return {
				year: parseInt(tmpArr[0], 10),
				month: parseInt(tmpArr[1], 10) - 1,
				day: parseInt(tmpArr[2], 10)
			};
		}
		return 0;
	}

	compareYears(first, second): boolean {
		if (!first || !second) {
			return false;
		}

		const SEPARATOR = '-';

		const [firstYear] = first.split(SEPARATOR);
		const [secondYear] = second.split(SEPARATOR);

		return firstYear === secondYear;
	}

	compareDates(first, second): boolean {
		if (first && second) {
			return new Date(first) < new Date(second);
		}

		return false;
	}

	getYear(date): number {
		if (date) {
			date = this.checkTypeof(date);
			const tmpArr = date.split('-');
			return parseInt(tmpArr[0], 10);
		}
		return 0;
	}

	getMonth(date): number {
		if (date) {
			date = this.checkTypeof(date);
			const tmpArr = date.split('-');
			return parseInt(tmpArr[1], 10) - 1;
		}
		return 0;
	}

	getDay(date): number {
		if (date) {
			date = this.checkTypeof(date);
			const tmpArr = date.split('-');
			return parseInt(tmpArr[2], 10);
		}
		return 0;
	}

	checkTypeof(date) {
		return typeof date === 'string' ? date : this.getDateInFormat(date, 'date');
	}

	calcDateRange = dueDateString => {
		const minutesPerDay = 86400000;
		const dueDate: any = new Date(dueDateString);
		const nowDate: any = new Date();
		const utcDue = Date.UTC(
			dueDate.getFullYear(),
			dueDate.getMonth(),
			dueDate.getDate()
		);
		const utcNow = Date.UTC(
			nowDate.getFullYear(),
			nowDate.getMonth(),
			nowDate.getDate()
		);

		return Math.floor((utcDue - utcNow) / minutesPerDay);
	};

	compareTimes(first, second) {
		console.log(first, second);
		if (first && second) {
			return this.getTimeExp(first) < this.getTimeExp(second);
		}

		return false;
	}

	convertDatesToUTC(
		arr = [],
		startDate = '',
		endDate = '',
		startTime = '',
		endTime = ''
	) {
		return arr.map(event => {
			if (startDate) {
				event[startDate] = this.createDateAsUTC(event[startDate]);
			}

			if (endDate) {
				event[endDate] = this.createDateAsUTC(event[endDate]);
			}

			if (startTime) {
				// event[startTime] = this.timeFilter.transform(event[startTime], '12h');
			}

			if (endTime) {
				// event[endTime] = this.timeFilter.transform(event[endTime], '12h');
			}

			return event;
		});
	}

	getTimeConvertedTo12(time: Date) {
		const hours = this.getHour(time);
		const minutes = this.getMinutes(time);
		const l = `${hours}:${minutes}`;
		return this.timeConverter.convert24to12(l);
	}

	convertDateTo12(dateExp) {
		const d = new Date(dateExp),
			h = d.getHours(),
			m = this.timeConverter.checkPadTime(d.getMinutes());
		let _time;

		_time = h >= 12 ? `${h - 12}:${m} PM` : `${h}:${m} AM`;

		if (_time.slice(0, 2) === '0:') {
			_time = `12${_time.slice(1)}`;
		}

		return _time;
	}

	convertDateTimeForPicker(
		event,
		startDate = '',
		endDate = '',
		startTime = '',
		endTime = ''
	) {
		const updatedEvent = Object.assign({}, event);

		if (startDate && updatedEvent[startDate]) {
			updatedEvent[startDate] = this.createDateAsUTC(event[startDate]);
		}

		if (endDate && updatedEvent[endDate]) {
			updatedEvent[endDate] = this.createDateAsUTC(event[endDate]);
		}

		if (startTime) {
			if (
				updatedEvent[startTime] &&
				this.isIn24Format(updatedEvent[startTime])
			) {
				// updatedEvent[startTime] = this.timeFilter.transform(event[startTime], '12h');
				updatedEvent[startTime] = this.getTimeConvertedTo12(event[startTime]);
			}
		}

		if (endTime) {
			if (updatedEvent[endTime] && this.isIn24Format(updatedEvent[endTime])) {
				// updatedEvent[endTime] = this.timeFilter.transform(event[endTime], '12h');
				updatedEvent[endTime] = this.getTimeConvertedTo12(event[endTime]);
			}

			return updatedEvent;
		}
	}

	setEndTime(startTime, format?): string {
		const isIn24Format = this.isIn24Format(startTime);
		const startTime24 = isIn24Format
			? startTime
			: this.timeConverter.convert12to24(startTime);
		const startHour = this.getHour(startTime24);
		let startMin: any = this.getMinutes(startTime24);

		let finishHour: any = startHour + 1;

		if (finishHour > 23) {
			finishHour = 0;
		}

		if (format === '24h') {
			finishHour = `0${finishHour}`.slice(-2);
			startMin = `0${startMin}`.slice(-2);
			const endTime = `${finishHour}:${startMin}:00`;
			return endTime;
		}
		const endTime = `${finishHour}:${startMin}`;
		return this.timeConverter.convert24to12(endTime);
	}

	createDateAsUTC(date: any) {
		const time = new Date(date).getTime();
		date = new Date(time);

		return new Date(
			date.getUTCFullYear(),
			date.getUTCMonth(),
			date.getUTCDate(),
			date.getUTCHours(),
			date.getUTCMinutes(),
			date.getUTCSeconds()
		);
	}

	calcDate(date1, date2) {
		let days, day, diff;
		diff = Math.floor(date1.getTime() - date2.getTime());
		day = 1000 * 60 * 60 * 24;
		days = Math.floor(diff / day);
		return days;
	}

	getDateAndTime(date, time = '') {
		const zeroHours = '00:00:00';
		if (!time) {
			time = zeroHours;
		}
		return new Date(`${date} ${time}`);
	}

	convertTimeToSeconds(time: string): number {
		if (time) {
			const timeArr = time.split(':');

			// minutes are worth 60 seconds. Hours are worth 60 minutes.
			return +timeArr[0] * 60 * 60 + +timeArr[1] * 60 + +timeArr[2];
		}
		return 0;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./shared/services/helpers/time-service/time.service.ts